import { Component, Input, OnChanges } from "@angular/core";
import { DynamicReportService } from "@reports/_services/dynamicReports.service";
import { ReportTypesNavLabels } from "@reports/enums/ReportTypesNavLabels";
import { IDynamicReportSchedule } from "@reports/models/IDynamicReportSchedule";
import { TranslationService } from "@services/translation.service";
import { IReportDefinitionHistory } from "../../models/IReportDefinition";
import "./report-card.component.scss";

@Component({
    selector: "report-card",
    template: require("./report-card.component.html")
})
export class ReportCardComponent implements OnChanges {

    @Input() reportDefinitionHistory: IReportDefinitionHistory;
    @Input() historyView: boolean;

    // ---

    title: string;
    subtitle: string;
    icon: string;

    rowDataSource: String;
    isSystemReport: boolean;

    schedule: IDynamicReportSchedule;

    constructor(
        private readonly dynamicReportService: DynamicReportService,
        private readonly translationService: TranslationService
    ) {
    }

    ngOnChanges() {
        if (!this.reportDefinitionHistory || !this.reportDefinitionHistory.definition) {
            this.clearTitle();
            return;
        }

        var reportType = this.dynamicReportService.getReportType(this.reportDefinitionHistory.definition);
        this.subtitle = reportType == ReportTypesNavLabels.System
            ? this.translationService.t("Reports.SystemReport")
            : this.translationService.t("Reports.CustomReport");
        this.isSystemReport = reportType == ReportTypesNavLabels.System ? true : false;

        if (this.historyView && this.reportDefinitionHistory?.latest?.ReportScheduleId) {
            this.loadSchedule();
        }

        this.updateDisplay();
    }

    // ---

    private loadSchedule() {
        if (!this.reportDefinitionHistory) {
            return;
        }

        this.dynamicReportService.getReportSchedules({ ReportDefinitionId: this.reportDefinitionHistory.definition.Id }).then(schedules => {

            this.schedule = schedules.find(s => s.Id == this.reportDefinitionHistory?.latest.ReportScheduleId);
        }).finally(() => {
            this.updateDisplay();
        });
    }

    private clearTitle(): void {
        this.title = "";
    }

    private updateDisplay(): void {
        this.title = this.getTitle();
        this.icon = this.getIcon();
    }

    private getIcon(): string {
        if (this.historyView) {
            return (this.schedule) ? "date_range" : "person";
        }

        return this.reportDefinitionHistory?.definition?.icon ?? "date_range";
    }

    private getTitle(): string {
        if (this.historyView) {
            if (this.schedule) {
                return this.translationService.t("ReportCard.ScheduledLabel", this.schedule.Name);
            }

            return this.reportDefinitionHistory.lastRanByLabel;
        }

        if (this.isSystemReport) {
            return this.reportDefinitionHistory.definition.Parameters.TranslatedTitle;
        }

        return this.reportDefinitionHistory.definition.Title;
    }
}
